<template v-if="data?.isActive">
    <div class="dhf-form">
        <p v-if="data.formLabel" class="dhf-form__section-title" :aria-label="data.formLabel">
            {{ data.formLabel }}
        </p>
        <form
            :action="data.href"
            class="dhf-form__form"
            :class="{ 'dhf-form__form--has-focus': isFocused }"
            method="post"
            @submit="handleSubmit"
        >
            <label class="dhf-form__input-label" :for="data.id" :aria-label="data.label">
                {{ data.label }}
            </label>
            <span class="dhf-form__input-field">
                <input
                    :id="data.id"
                    v-model="formInput"
                    :type="data.type"
                    :name="data.name"
                    :placeholder="data.placeholder"
                    class="dhf-form__input"
                    @focus="isFocused = true"
                    @blur="isFocused = false"
                />
                <button
                    type="submit"
                    class="dhf-form__button"
                    :data-testId="`dhf-footer-onSubmit-${data.label}`"
                    :aria-label="`Submit ${data.name}`"
                >
                    <DhfIcon name="arrow-angle" />
                </button>
            </span>
        </form>
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useTracking } from '@/composables/useTracking';
import DhfIcon from '@/components/dhf-icon/dhf-icon.vue';
import type { Input } from '@/types/shared-types';
import {
    LOCATOR_TRACKING_NAME,
    LOCATOR_STORAGE_KEY,
    NEWSLETTER_TRACKING_NAME,
    NEWSLETTER_STORAGE_KEY,
} from '@/constants/form.constants';

const props = withDefaults(
    defineProps<{
        data: Input;
        isNewsletter?: boolean;
        isLocator?: boolean;
    }>(),
    {
        isNewsletter: false,
        isLocator: false,
    }
);

const { doFooterDataLayerPush } = useTracking();
const formInput = ref<string>('');
const isFocused = ref(false);

const handleSubmit = () => {
    saveToLocalStorage(formInput.value);
    doFooterDataLayerPush(
        props.isLocator ? LOCATOR_TRACKING_NAME : NEWSLETTER_TRACKING_NAME,
        `${props.data.label} | ${props.data.href}`,
        props.data.href,
        props.data.label
    );
};

function saveToLocalStorage(inputValue: string) {
    if (props.isLocator) {
        sessionStorage.setItem(LOCATOR_STORAGE_KEY, window.btoa(`loc=${inputValue}`));
    }
    if (props.isNewsletter) {
        localStorage.setItem(NEWSLETTER_STORAGE_KEY, inputValue);
    }
}
</script>

<style lang="scss">
@import './dhf-form.scss';
</style>
